// utils/phone.ts — єдиний модуль телефону (REFACTOR_PLAN п.2).
// Зберігання — завжди E.164 "+380XXXXXXXXX", відображення — "+380 XX XXX XX XX".
// Логіка маски портована з pages/login.vue (еталонна реалізація).

export const PHONE_PREFIX = "+380 ";
export const PHONE_PLACEHOLDER = "+380 XX XXX XX XX";
export const PHONE_FORMAT_HINT = "Введіть номер у форматі +380 XX XXX XX XX";
export const PHONE_OPERATOR_HINT =
  "Невірний код оператора. Перевірте номер телефону.";

export const UA_MOBILE_OPERATOR_CODES: ReadonlySet<string> = new Set([
  "39", // Kyivstar
  "50", // Vodafone
  "63", // lifecell
  "66", // Vodafone
  "67", // Kyivstar
  "68", // Kyivstar
  "73", // lifecell
  "91", // 3Mob / TriMob
  "92", // PEOPLEnet (legacy)
  "93", // lifecell
  "94", // Intertelecom (legacy)
  "95", // Vodafone
  "96", // Kyivstar
  "97", // Kyivstar
  "98", // Kyivstar
  "99", // Vodafone
]);

export function digits(v: unknown = ""): string {
  return String(v ?? "").replace(/\D+/g, "");
}

/** До 9 цифр національного номера (без коду країни), з будь-якого вводу. */
export function uaLocalDigits(v: unknown = ""): string {
  let d = digits(v);
  if (d.startsWith("380")) d = d.slice(3);
  else if (d.startsWith("0")) d = d.slice(1);
  return d.slice(0, 9);
}

/** Маска відображення; коректно форматує і частковий ввід. */
export function formatUaPhone(v: unknown = ""): string {
  const d = uaLocalDigits(v);
  if (!d.length) return PHONE_PREFIX;
  if (d.length <= 2) return `${PHONE_PREFIX}${d}`;
  if (d.length <= 5) return `${PHONE_PREFIX}${d.slice(0, 2)} ${d.slice(2)}`;
  if (d.length <= 7)
    return `${PHONE_PREFIX}${d.slice(0, 2)} ${d.slice(2, 5)} ${d.slice(5)}`;
  return `${PHONE_PREFIX}${d.slice(0, 2)} ${d.slice(2, 5)} ${d.slice(
    5,
    7,
  )} ${d.slice(7)}`;
}

/** "+380XXXXXXXXX" для повного номера, інакше "". */
export function toE164(v: unknown = ""): string {
  const d = uaLocalDigits(v);
  return d.length === 9 ? `+380${d}` : "";
}

/** Маска для повного номера (E.164 чи будь-який повний ввід), інакше "". */
export function maskFromE164(v: unknown = ""): string {
  return uaLocalDigits(v).length === 9 ? formatUaPhone(v) : "";
}

export function uaOperatorCode(v: unknown = ""): string {
  const d = uaLocalDigits(v);
  return d.length >= 2 ? d.slice(0, 2) : "";
}

export function isValidUaOperator(v: unknown = ""): boolean {
  return UA_MOBILE_OPERATOR_CODES.has(uaOperatorCode(v));
}

/** Повні 9 цифр + реальний код мобільного оператора. */
export function isValidUaPhone(v: unknown = ""): boolean {
  return uaLocalDigits(v).length === 9 && isValidUaOperator(v);
}
